// src/components/HeroSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import summitBg from '../assets/images/summit.jpeg';

const HeroSection = () => {
  return (
    <section 
      className="hero-section"
      style={{ 
        backgroundImage: `url(${summitBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="hero-overlay"></div>
      
      {/* TOP LOGOS */}
      <div className="hero-top-logos">
        <div className="hero-top-logos-row">
          <div className="hero-top-logo-item">
            <img 
              src="/images/hero/presidency.png" 
              alt="Presidency" 
              className="img-zoom"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span>Presidency</span>
          </div>
          <div className="hero-top-logo-divider"></div>
          <div className="hero-top-logo-item">
            <img 
              src="/images/hero/foreign-affairs.jpg" 
              alt="Ministry of Foreign Affairs" 
              className="img-zoom"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span>Foreign Affairs</span>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="hero-content">
        <h1 className="hero-main-title">
          AICIS <span className="hero-year">2026</span>
        </h1>
        <h2 className="hero-subtitle-text">
          GLOBAL SUMMIT
        </h2>
        <p className="hero-description-text">
          Africa Infrastructure, Climate Change, Security & Green Investment Summit
        </p>
        <div className="hero-date-location">
          <span>25-28 NOVEMBER 2026</span>
          <span className="hero-divider">•</span>
          <span>ABUJA, NIGERIA</span>
        </div>
        <div className="hero-buttons">
          {/* Register button goes directly to /register */}
          <Link to="/register" className="hero-btn primary">
            Register Now
          </Link>
          <Link to="/events/pre-summit" className="hero-btn secondary">
            2026 AICIS Pre Summit
          </Link>
          <Link to="/activities/speakers" className="hero-btn speakers-btn">
            <span className="speakers-btn-icon">🎤</span>
            Discover Speakers
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;